const styles = {
  radioButtons: {
    display: "flex",
    justifyContent: "space-between",
    maxWidth: "40%",
  },
  boolInputContainer: {
    display: "flex",
    alignItems: "center",
    flex: 1,
  },
  preLabel: {
    maxWidth: "65%",
    flex: 1,
  },
};

export default styles;
